import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=15c4da2a&"
import script from "./CookieConsent.vue?vue&type=script&lang=js&"
export * from "./CookieConsent.vue?vue&type=script&lang=js&"
import style0 from "./CookieConsent.vue?vue&type=style&index=0&id=15c4da2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports